<mat-dialog-content>
    To install the app, press "Share" <mat-icon>ios_share</mat-icon><br />
    Then press "Add to Home Screen" <mat-icon>add_box</mat-icon>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="primary" mat-dialog-close>
        <mat-icon>check</mat-icon>
    </button>
</mat-dialog-actions>